import {createBridgeCaller} from '../BridgeApi';
import {createClassLogger, Logger} from '../../utils/Logging';
import {InstallerBridge, FileOperationView, SubscribeCallback} from '../installerBridge';

const BRIDGE_NAME = 'installer';
const logger: Logger = createClassLogger('InstallerBridge:Launcher');
const executeInstallerBridgeCall = createBridgeCaller(BRIDGE_NAME, logger);

const installerLauncher: InstallerBridge = {
    /**
     * Set metadata on launcher about view parameters for install stats
     */
    setFileOperationView: (view: FileOperationView): Promise<void> =>
        executeInstallerBridgeCall('setfileoperationview', [view]),

    /**
     * Subscribe to event
     */
    subscribe: (type: string, callback: SubscribeCallback): Promise<number> =>
        executeInstallerBridgeCall('subscribe', [type, callback]),

    /**
     * Add a given url to the launcher's history stack
     */
    unsubscribe: (subscriptionId: number): Promise<boolean> =>
        executeInstallerBridgeCall('unsubscribe', [subscriptionId])
};

export default installerLauncher;
